import React from "react";
import { StyledVideo } from "./styles";
import { useMediaQuery } from "react-responsive";

interface Props {
  id: string;
  src: string;
  muted?: boolean;
  controls?: boolean;
  autoPlay?: boolean;
  playsInline?: boolean;
  className?: string;
  isPopUp?: boolean;
}

export const size = {
  phone: 480,
};

const Video = ({ src, isPopUp = false, ...props }: Props) => {
  const isMobile = useMediaQuery({ maxWidth: size.phone });
  const shouldApplyStyle = props.id === "videos-2" || props.id === "video-2";
  
  const inlineStyle =
  shouldApplyStyle
    ? {
        display: "block",
        width: isMobile ? "50%" : "40%",
        margin: "0 auto",
      }
    : undefined;

  return (
    isPopUp ? (
      <StyledVideo {...props}>
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </StyledVideo>
    ) : (
      <StyledVideo {...props}  
      style={inlineStyle}>
        <source data-src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </StyledVideo>
    )
  );
};

export default Video;
